import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ErrorComponent } from './ErrorComponent';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // eslint-disable-next-line no-unused-vars
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log('error', error);
    console.log('errorInfo', errorInfo);
  }

  render() {
    const { hasError, error } = this.state;
    const { children, theme } = this.props;
    if (hasError) {
      // You can render any custom fallback UI
      return <ErrorComponent content={error} theme={theme} />;
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.shape,
};

export default ErrorBoundary;
